import without from 'lodash-es/without'
import { useState } from 'react'

export type Options = {
  allowZeroActive?: boolean
  allowMultipleActive?: boolean
}

export const useAccordionState = (initialState: boolean[], options?: Options) => {
  const [activeState, setActiveState] = useState<boolean[]>(initialState)

  const toggle = (index: number) => {
    if (activeState.length - 1 >= index) {
      setActiveState((state) => {
        return state.map((element, elementIndex) => {
          if (index === elementIndex) {
            return !options?.allowZeroActive && element && without(state, false).length === 1
              ? element
              : !element
          }

          return options?.allowMultipleActive ? element : false
        })
      })
    }
  }

  return {
    activeState,
    setActiveState,
    toggle,
  }
}
